import { AppLayout } from 'layouts';
import { GiveNow, GivingScopeEnum, GivingsList } from 'features/givings';
import { useGetPathToEntityDetail, useGivingNavigation } from 'pages/hooks';
import { useGiveTransactionParams } from '../hooks';

type P = {
  scope: GivingScopeEnum;
};

const PageGivingsList = ({ scope }: P) => {
  const getPathToEntityDetail = useGetPathToEntityDetail();
  const { navigateToGiveNow, navigateToGivingBrowse } = useGivingNavigation();
  const { paymentRedirectUrl } = useGivingNavigation();
  const giveTransaction = useGiveTransactionParams();

  return (
    <AppLayout>
      {scope === GivingScopeEnum.NOW ? (
        <GiveNow
          getPathToGivingDetail={(id) => getPathToEntityDetail(id, { entityType: 'giving' })}
          giveTransaction={giveTransaction}
          navigateToGiveNow={navigateToGiveNow}
          navigateToGivingBrowse={navigateToGivingBrowse}
          paymentRedirectUrl={paymentRedirectUrl}
          scope={scope}
        />
      ) : (
        <GivingsList
          getPathToGivingDetail={(id) => getPathToEntityDetail(id, { entityType: 'giving' })}
          navigateToGiveNow={navigateToGiveNow}
          navigateToGivingBrowse={navigateToGivingBrowse}
          scope={scope}
        />
      )}
    </AppLayout>
  );
};

export default PageGivingsList;
